import { render, staticRenderFns } from "./detail_basic.vue?vue&type=template&id=321436a5"
import script from "./detail_basic.vue?vue&type=script&lang=js"
export * from "./detail_basic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('321436a5')) {
      api.createRecord('321436a5', component.options)
    } else {
      api.reload('321436a5', component.options)
    }
    module.hot.accept("./detail_basic.vue?vue&type=template&id=321436a5", function () {
      api.rerender('321436a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/interview/interview_detail_report/form/components/detail_basic.vue"
export default component.exports